import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useVirtualization } from "./hooks/useVirtualization";
import { getModelConfig } from "../utils/models";
import { SECTION_TYPES } from "./constants/event";
import EventCardEPG from "./EPGEventCard";
import EPGSportCard from "./EPGSportCard";
import EPGLeagueCard from "./EPGLeagueCard";
import { scrollIntoViewWithinContainer } from "./utils/shared/scrollIntoView";
import "./epg.scss";

const EPGSectionRow = ({ items, title, rowId, rowType, virtualizationParams, onEnterPress }) => {
    const { ref, focusKey } = useFocusable({
        onFocus: () => {
            if (ref.current) {
                if (getModelConfig().epg.customScrollBehavior) {
                    scrollIntoViewWithinContainer(ref.current, 'scrollingRows');
                } else {
                    ref.current.scrollIntoView({
                        behavior: getModelConfig().epg.scrollBehavior,
                        block: "nearest",
                        inline: "nearest",
                    });
                }
            }
        },
    });
    const { scrollingRef, contentStyle, virtualItems, onItemFocus } = useVirtualization({
        items,
        ...virtualizationParams,
    });

    const onAssetFocus = (focusProps) => {
        onItemFocus(focusProps);
    };

    const rowClassName = rowType === SECTION_TYPES.EVENTS ? "sectionRowWrapper" : "shortcutRowWrapper";

    return (
        <FocusContext.Provider value={focusKey}>
            <h2 className="rowTitle">{title}</h2>
            <div ref={ref} className={rowClassName}>
                <div ref={scrollingRef} className="sectionRowScrollingWrapper">
                    <div className="sectionRowScrollingContent" style={contentStyle}>
                        {rowType === SECTION_TYPES.EVENTS && virtualItems.map(({ item, index }) => <EventCardEPG event={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />)}
                        {rowType === SECTION_TYPES.SPORTS && virtualItems.map(({ item, index }) => <EPGSportCard sport={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />)}
                        {rowType === SECTION_TYPES.LEAGUES && virtualItems.map(({ item, index }) => <EPGLeagueCard league={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />)}
                    </div>
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default EPGSectionRow;
